export function readCanvasAsBlob(canvas: HTMLCanvasElement, type: string): Promise<Blob> {
    return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
            if (blob === null) {
                return reject(new Error('Canvas blob is null'))
            }
            return resolve(blob)
        }, type)
    })
}
